import React from 'react';

import { AuthService } from 'modules/authService/service';

export const AuthServiceContext = React.createContext<AuthService>(null as any);
